<template>
  <q-dialog v-if="formProperty && formProperty.ocrType" v-model="visibleDlg" class="ocrDlg">
    <q-card>
      <q-card-section class="q-pb-none">
        <div class="row items-center">
          <div class="text-h6">{{ ocrType === 1 ? "Strichcode Scan" : ocrType === 2 ? "QR-Code Scan" : "Schrifterkennung" }}</div>
          <q-space/>
          <q-btn icon="close" flat round dense v-close-popup/>
          <div class="text-subtitle2" v-if="ocrType === 3">Bitte den Text genau zentrieren, auf gleichmäßige Ausleuchtung achten und das Bild gerade fotografieren.</div>
        </div>
      </q-card-section>

      <q-card-section>
        <qrcode-stream height="40px" @decode="onQRDone" @init="onInit" v-if="ocrType === 2"/>
        <ocr-comp @OCRInitStarted="onCameraInitStarted('OCR')" @OCRReady="onCameraReady('OCR')" @OCRDone="onOCRDone" @OCRError="onOCRError" v-if="ocrType === 3"/>
        <StreamBarcodeReader @loaded="onCameraReady('Strichcode')" @result="onOCRDone" v-if="ocrType === 1"></StreamBarcodeReader>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn color="primary" flat label="OCR Scan" v-if="ocrType === 3" @click="clickOCR"/>
        <q-btn label="Abbrechen" color="grey" flat @click="visibleDlg=false"/>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>

import {StreamBarcodeReader} from "vue-barcode-reader";
import OcrComp from "components/tech/ocr-comp.vue";
import {QrcodeCapture, QrcodeDropZone, QrcodeStream} from 'vue3-qrcode-reader'

export default {
  props: [
    'formProperty',
    'showDlg'
  ],
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture,
    OcrComp,
    StreamBarcodeReader
  },
  computed: {
    ocrType() {
      return Number(this.formProperty?.ocrType)
    },
    visibleDlg: {
      get() {
        return this.showDlg;
      },
      set(value) {
        this.$emit('dlgClose');
      }
    }
  },
  data() {
    return {
      ocrInitLoading: false,
      cameraInitTimeout: null
    }
  },

  watch: {
    showDlg(isVisible) {
      console.info(`[OCR] Scan-Dialog ${isVisible ? 'geöffnet' : 'geschlossen'}`, {
        ocrType: this.formProperty?.ocrType,
        normalizedOcrType: this.ocrType,
        field: this.formProperty?.nativename
      })

      if (isVisible) {
        this.startCameraInitTimeout()
      } else {
        this.clearCameraInitTimeout()
      }
    }
  },

  methods: {
    // -----------------------------------------------------------
    // ---------------------- OCR Scan -----------------------
    // -----------------------------------------------------------
    clickOCR() {
      console.info('[OCR] Button „OCR Scan“ wurde gedrückt', {
        field: this.formProperty?.nativename
      })
      this.eventBus.doOCR()
    },

    onOCRDone(result) {
      console.info('[OCR] Texterkennung wurde erfolgreich abgeschlossen')
      //logger.info("onOCRDone: " + result.text)
      this.visibleDlg = false
      this.$emit('ocrDone', result.text);
    },

    onQRDone(result) {
      console.info('[QR-Code] Scan wurde erfolgreich abgeschlossen')
      // logger.info("onQRDone: " + result)
      this.visibleDlg = false
      this.$emit('ocrDone', result);
    },

    onOCRError(error) {
      this.visibleDlg = false
      this.showCameraInitError(error, 'OCR')
    },

    onCameraInitStarted(scanType) {
      console.info(`[${scanType}] Anfrage an die Kamera-API wurde gestartet`)
      this.ocrInitLoading = true
      this.startCameraInitTimeout(scanType)
    },

    onCameraReady(scanType) {
      console.info(`[${scanType}] Kamera ist einsatzbereit`)
      this.ocrInitLoading = false
      this.clearCameraInitTimeout()
    },

    // -----------------------------------------------------------
    // ---------------------- QR Code Scan -----------------------
    // -----------------------------------------------------------
    async onInit(promise) {
      console.info('[QR-Code] Kamera-Initialisierung gestartet')
      this.onCameraInitStarted('QR-Code')
      try {
        await promise
        this.onCameraReady('QR-Code')
      } catch (error) {
        this.visibleDlg = false
        this.showCameraInitError(error, 'QR-Code')
      } finally {
        this.ocrInitLoading = false
      }
    },

    showCameraInitError(error, scanType) {
      this.clearCameraInitTimeout()
      this.ocrInitLoading = false
      const errorMsg = this.getCameraInitErrorMsg(error)

      console.error(`[${scanType}] Kamera konnte nicht initialisiert werden`, error)
      this.formProperty.errorMsg = errorMsg
      this.formProperty.invalid = true

      this.$nextTick(() => {
        this.$q.dialog({
          title: 'Kamera konnte nicht aktiviert werden',
          message: errorMsg,
          ok: {
            color: 'primary',
            label: 'OK'
          }
        })
      })
    },

    startCameraInitTimeout(scanType = 'OCR') {
      this.clearCameraInitTimeout()
      this.cameraInitTimeout = window.setTimeout(() => {
        const error = new Error('Die Kamera-Anfrage hat innerhalb von 15 Sekunden keine Antwort geliefert.')
        error.name = 'CameraInitializationTimeoutError'
        this.visibleDlg = false
        this.showCameraInitError(error, scanType)
      }, 15000)
    },

    clearCameraInitTimeout() {
      if (this.cameraInitTimeout !== null) {
        window.clearTimeout(this.cameraInitTimeout)
        this.cameraInitTimeout = null
      }
    },

    getCameraInitErrorMsg(error) {
      const errorName = error?.name || error?.constructor?.name || 'Unbekannter Fehler'
      const errorMessage = error?.message || (typeof error === 'string' ? error : '')
      const errorReasons = {
        NotAllowedError: 'Der Kamerazugriff wurde verweigert oder durch eine Browser- bzw. Systemrichtlinie blockiert.',
        NotFoundError: 'Es wurde keine verfügbare Kamera gefunden.',
        NotSupportedError: 'Der Kamerazugriff wird in diesem Browser oder ohne HTTPS nicht unterstützt.',
        NotReadableError: 'Die Kamera konnte nicht gelesen werden. Möglicherweise wird sie bereits von einer anderen Anwendung verwendet.',
        OverconstrainedError: 'Keine Kamera erfüllt die angeforderten Einstellungen.',
        StreamApiNotSupportedError: 'Die Kamera-API wird von diesem Browser nicht unterstützt.',
        SecurityError: 'Der Browser hat den Kamerazugriff aus Sicherheitsgründen blockiert.',
        AbortError: 'Das Starten der Kamera wurde abgebrochen.',
        TypeError: 'Die Kamera-Anfrage ist ungültig oder die Seite wird nicht in einem sicheren Kontext ausgeführt.',
        CameraInitializationTimeoutError: 'Die Kamera hat nicht auf die Anfrage reagiert. Prüfen Sie eine offene Berechtigungsabfrage sowie die Kamera- und Browserberechtigungen.'
      }
      const reason = errorReasons[errorName] || 'Die Kamera konnte aus einem unbekannten Grund nicht initialisiert werden.'
      const technicalReason = errorMessage && errorMessage !== reason
        ? `${errorName}: ${errorMessage}`
        : errorName

      return `${reason} Technischer Grund: ${technicalReason}`
    }
  },

  beforeUnmount() {
    this.clearCameraInitTimeout()
  }
}
</script>

<style lang="sass">
.ocrDlg
  height: 50%

  .q-field--dense
    font-size: 13px

  .q-field--dense .q-field__bottom
    padding-top: 2px
</style>
